// ===== TIPOS DE DADOS =====

export interface IParteProcesso {
  tipo: string;
  nome: string;
  representada: boolean;
}

export interface IDadosPartes {
  partesProcesso: IParteProcesso[];
  partesRepresentadas: string[];
}

// ===== PROPRIEDADES DO COMPONENTE PRINCIPAL =====

export interface StepPartesProps {
  step: number;
  currentStep: number;
  setPartes: (partesProcesso: IParteProcesso[], partesRepresentadas: string[]) => void;
  setCurrentStep: (step: number) => void;
  validando: boolean;
  setValidando: (validando: boolean) => void;
  initialPartesProcesso?: IParteProcesso[];
  initialPartesRepresentadas?: string[];
}

// ===== PROPRIEDADES DOS SUBCOMPONENTES =====

export interface PartesEnvolvidasProps {
  partes: IParteProcesso[];
  onChange: (partes: IParteProcesso[]) => void;
  erros: any;
}

export interface PartesRepresentadasProps {
  representadas: string[];
  autoRepresentadas: string[];
  onAdd: (nome: string) => void;
  onRemove: (nome: string) => void;
  erros: any;
}

export const QUALIFICACOES: string[] = [
  'Adverso',
  'Apelado',
  'Apelante',
  'Autor',
  'Autora',
  'Executado',
  'Exequente',
  'Reclamante',
  'Reclamada',
  'Ré',
  'Réu',
  'Requerente',
  'Requerido',
  'Solicitante'
];


